import { FontAwesome5 } from '@expo/vector-icons';
import {
  FontsType,
  secondaryFontFamily,
  styled,
} from '@openeducation/oe-rn-themes';
import React, { memo } from 'react';
import type { StyleProp } from 'react-native';
import { ViewStyle, TextStyle } from 'react-native';

import { flex } from '../../style-utils';
import { OEText } from '../oe-text/oe-text';
import { OETouchableOpacity } from '../oe-touchable-opacity/oe-touchable-opacity';

export interface LinkButtonProps {
  text: string;
  onPress: () => void;
  fontSize?: number;
  color?: string;
  iconName?: string;
  disabled?: boolean;
  fontType?: keyof FontsType;
  textAlign?: TextStyle['textAlign'];
  style?: StyleProp<ViewStyle>;
}

export const LinkButton = ({
  text,
  onPress,
  color,
  fontSize = 14,
  fontType = 'medium',
  textAlign = 'left',
  iconName = 'chevron-right',
  disabled,
  style,
}: LinkButtonProps) => {
  return (
    <OETouchableOpacity
      onPress={onPress}
      disabled={disabled}
      style={[flex('flex-row', 'align-items-center'), style]}
    >
      <LinkButtonText
        fontType={fontType}
        textAlign={textAlign}
        fontSize={fontSize}
        color={color}
      >
        {text}
      </LinkButtonText>
      <ButtonIcon name={iconName} size={fontSize * 0.7} color={color} />
    </OETouchableOpacity>
  );
};

const LinkButtonText = styled(OEText).attrs(({ theme, color }) => ({
  color: color || theme.color.primary,
  fontFamily: secondaryFontFamily,
}))`
  margin-right: 4px;
`;

const ButtonIcon = styled(FontAwesome5).attrs(({ theme, color }) => ({
  color: color || theme.color.primary,
}))``;

export default memo(LinkButton);
